import { Injectable } from '@angular/core';
import { TcmWebHubConnectionService } from '../internals/tcm-web-hub-connection.service';
import { SingletonCheckHelper } from '../helpers/singleton-check.helper';
import { ApiAppointmentChangedEvent, OrderStatusChangedEvent } from '../models/api-events';
import { Subject } from 'rxjs/internal/Subject';
import { AppointmentChangedEvent } from '../models/api-events/appointment-changed-event';

@Injectable({
    providedIn: 'root'
})
export class ApiEventsService {

    get apiAppointmentChangedEvent$() {
        return this.apiAppointmentChangedEvent.asObservable();
    }
    get appointmentChangedEvent$() {
        return this.appointmentChangedEvent.asObservable();
    }
    get orderStatusChangedEvent$() {
        return this.orderStatusChangedEvent.asObservable();
    }

    private readonly apiAppointmentChangedEvent = new Subject<ApiAppointmentChangedEvent>();
    private readonly appointmentChangedEvent = new Subject<AppointmentChangedEvent>();
    private readonly orderStatusChangedEvent = new Subject<OrderStatusChangedEvent>();

    constructor(connection: TcmWebHubConnectionService) {
        SingletonCheckHelper.ensureSingleton(this);

        connection.userIsAuthenticated$.subscribe(userIsAuthenticated => {
          if (userIsAuthenticated && connection){
            connection.on(x => x.Receive_Scheduler_Changed, (x) => this.apiAppointmentChangedEvent.next(x));
            connection.on(x => x.Notify_Scheduler_Changed, (x) => this.appointmentChangedEvent.next(x));
            connection.on(x => x.Notify_OrderStatus_Changed, (x) => this.orderStatusChangedEvent.next(x));
          }
        })

    }
}
